<template>
  <q-page class="schedules">
    <div class="column absolute-center" v-show="schedules.length == 0">
      <q-icon name="departure_board" style="font-size: 80px; margin:0 auto" />
      <span
        class="text-weight-bold text-center q-pt-md"
        style="line-height: 1; font-size:22px"
      >Não foram localizados horários.</span>
    </div>

    <div v-if="schedulesOpens.message !== 'Não existe embarque em aberto.'">
      <div style="heigth:100px; background: linear-gradient(to bottom, #016D65 50%, #EAEAEA 50%);">
        <div class="column items-center q-pb-lg">
          <div class="row" style="width: 90%;">
            <div class="q-py-md" style="color: #fff">
              <q-icon name="watch_later" style="font-size:1.4em" class="q-pl-xs" />
              <span class="text-caption text-weight-bold q-pl-sm">Embarque em andamento</span>
            </div>
            <q-space></q-space>
            <div class="q-px-sm q-py-md" style="color: #fff">
              <q-icon name="directions_bus" style="font-size:1.2em" />
              <span class="text-caption q-pl-xs">
                CARRO
                <span class="text-weight-bold">{{schedulesOpens.number_bus}}</span>
              </span>
            </div>
          </div>
          <div style="width: 90%; heigth: 50px; background: white; border-radius: 0 0 10px 10px;">
            <div class="row text-left q-pa-md">
              <span
                class="text-subtitle2 text-weight-bold"
              >{{ cityToCamelCase(schedulesOpens.origin) }}</span>
              <q-icon
                v-if="schedulesOpens.destiny"
                name="arrow_forward"
                class="q-mx-sm"
                style="color: #37C100; font-size:1.5em"
              />
              <span
                class="text-subtitle2 text-weight-bold"
              >{{ cityToCamelCase(schedulesOpens.destiny) }}</span>
            </div>
            <div class="row text-left q-pl-md q-pb-sm">
              <div class="column" style="font-size: 10px">
                <span v-if="schedulesOpens.departure_travel" style="color: #7A8583">
                  Saída dia
                  <span
                    class="text-weight-bold"
                  >{{ schedulesOpens.departure_travel | formatDate }}</span>
                </span>
                <span style="color: #7A8583">
                  Saída da agência
                  <span
                    class="text-weight-bold"
                  >{{ schedulesOpens.departure | formatDate }}</span>
                </span>
              </div>
              <q-space></q-space>
              <div class="q-pr-md">
                <q-btn
                  @click="goToPassengers(schedulesOpens)"
                  no-caps
                  unelevated
                  label="Continuar"
                  class="no-shadow text-weight-bold"
                  text-color="white"
                  style="background-color: #3BA46A; border-radius: 6px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="Array.isArray(schedules) && schedules.length > 0" class="q-pt-md">
      <q-tabs
        v-model="buttonActive"
        dense
        class="text-black no-shadow"
        :indicator-color="indicatorColor"
        left-icon="none"
        right-icon="none"
        no-caps
      >
        <q-tab name="naoIniciado" label="Não iniciadas" icon="info" style="padding: 0 10px">
          <q-badge
            color="black"
            floating
            style="margin-right: 17px; margin-top: -3px;"
          >{{howManySchedulesTypes('naoIniciado')}}</q-badge>
        </q-tab>
        <q-tab name="emAndamento" label="Em andamento" icon="timer" style="padding: 0 10px">
          <q-badge
            color="warning"
            class="text-black"
            floating
            style="margin-right: 28px; margin-top: -3px;"
          >{{howManySchedulesTypes('emAndamento')}}</q-badge>
        </q-tab>
        <q-tab name="concluido" label="Concluídas" icon="check_circle" style="padding: 0 10px">
          <q-badge
            color="positive"
            floating
            style="margin-right: 16px; margin-top: -3px;"
          >{{howManySchedulesTypes('concluido')}}</q-badge>
        </q-tab>
      </q-tabs>
    </div>    
    <q-list class="schedules__travels">
      <div
        :key="index"
        :style="`animation-delay: ${index * 0.1}s;`"
        class="animated slideInUp q-pb-sm"
        v-for="(s, index) in filterByStatusBoarding()"
        v-ripple
        style="width:90%; margin: 0 auto;"
      >
        <div
          style="border-radius: 6px 6px 0 0; position: relative; bottom: -10px; z-index: -1"
          :style="`background-color: ${colorMenuCard}`"
          class="text-white schedules__section row"
        >
          <div class="schedules__title">
            <div
              :class="buttonActive === 'emAndamento' ? 'text-black': 'text-white'"
              class="schedules__title-icon"
            >
              <q-icon name="directions_bus" />
            </div>
            <div
              :class="buttonActive === 'emAndamento' ? 'text-black': 'text-white'"
              class="schedules__title-texte"
            >
              <div>CARRO {{ s.number_bus }}</div>
              <div v-if="s.boarding_alternative" class="text-bold q-pr-sm text-caption">Embarque alternativo</div>
            </div>
          </div>
        </div>

        <div style="background: #FFFFFF; border-radius: 0 10px 15px 10px">
          <div class="q-pa-sm">
            <div class="row q-py-sm">
              <div class="text-subtitle2 text-weight-bold" v-if="s.boarding_alternative">
                <span v-if="userMotorist">{{s.boarding_alternative_code}} -</span> {{ cityToCamelCase(s.alternative_agency) }}
              </div>
              <div class="text-subtitle2 text-weight-bold" v-else>
                <span v-if="userMotorist">{{s.boarding_code}} -</span> {{ cityToCamelCase(s.alternative_agency) }}
              </div>
              <q-icon
                v-if="!userMotorist"
                name="arrow_forward"
                class="q-mx-sm"
                style="color: #37C100; font-size:1.5em"
              />
              <div v-if="!userMotorist" class="text-subtitle2 text-weight-bold">{{ cityToCamelCase(s.destiny) }}</div>
            </div>

            <div class="row q-pa-xs">
              <div class="column">
                <span v-if="s.departure_travel && !userMotorist" class="text-caption" style="color: #7A8583">
                  Saída dia
                  <span class="text-weight-bold">{{ s.departure_travel | formatDate }}</span>
                </span>
                <span v-if="s.local_arrival" class="text-caption" style="color: #7A8583">
                  Chegada agência
                  <span class="text-weight-bold">{{ s.local_arrival | formatDate }}</span>
                </span>
                <span v-if="s.time_pause" class="text-caption" style="color: #7A8583">
                  Tempo parada:
                  <span class="text-weight-bold">{{ s.time_pause }} minutos</span>
                </span>
                <span class="text-caption" style="color: #7A8583">
                  Saída da agência
                  <span class="text-weight-bold">{{ s.departure | formatDate }}</span>
                </span>
                <span v-if="s.boarding_amount" class="text-caption" style="color: #7A8583">
                  Quantidade de embarque:
                  <span class="text-weight-bold">{{ s.boarding_amount }}</span>
                </span>
                <span v-if="s.landing_amount" class="text-caption" style="color: #7A8583">
                  Quantidade de desembarque:
                  <span class="text-weight-bold">{{ s.landing_amount }}</span>
                </span>
              </div>
              <q-space></q-space>
              <div class="row items-end">
                <q-btn
                  v-show="buttonActive === 'naoIniciado'"
                  :disable="schedulesOpens.message !== 'Não existe embarque em aberto.'"
                  @click="validOriginUserToOpenTravel(s)"
                  label="Iniciar"
                  no-caps
                  unelevated
                  text-color="white"
                  class="text-weight-bold"
                  :style="schedulesOpens.message === 'Não existe embarque em aberto.' ? 'background: #3BA46A': '' "
                />
                <q-btn
                  v-show="buttonActive === 'concluido' && s.edit === '1'"
                  :disable="schedulesOpens.message !== 'Não existe embarque em aberto.'"
                  @click="goToPassengers(s)"
                  label="Editar"
                  no-caps
                  unelevated
                  text-color="white"
                  class="text-weight-bold"
                  :style="schedulesOpens.message === 'Não existe embarque em aberto.' ? 'background: #3BA46A': '' "
                />
              </div>
            </div>
            <div v-show="s.user_opening !== 'S/U'" class="q-pt-sm">
              <q-separator inset class="full-width" />
              <span v-show="buttonActive === 'emAndamento'" class="text-weight-regular">
                Iniciado por:
                <span
                  class="text-weight-bold q-pt-sm"
                >{{ s.user_opening}}</span>
              </span>
              <span v-show="buttonActive === 'concluido'" class="text-weight-regular">
                Concluido por:
                <span
                  class="text-weight-bold q-pt-sm"
                >{{ s.user_opening }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </q-list>
    <search-bus v-show="schedules.length > 0" />

    <q-dialog
      v-model="confirmationOpenBoarding"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
      v-if="boardingData !== null"
    >
      <q-card>
        <div class="row" style="background: #016D65; border-radius: 0 0 40px 40px; height: 150px">
          <div class="text-center q-pt-md q-pb-sm full-width">
            <span class="text-h6 text-weight-bold" style="color:#fff">DESEJA INICIAR O EMBARQUE?</span>
          </div>
        </div>
        <div class="column q-py-md q-px-xl">
          <span class="text-weight-bold" style="color: #172C20">RESUMO DA VIAGEM</span>

          <div class="row q-py-md" style="color: #172C20">
            <q-icon name="directions_bus" style="font-size:1.2em" />
            <span class="text-subtitle2 q-pl-xs">
              CARRO
              <span class="text-weight-bold">{{boardingData.number_bus}}</span>
            </span>
          </div>

          <div class="row">
            <div
              class="text-subtitle2 text-weight-bold"
              style="color: #172C20"
            >{{ cityToCamelCase(boardingData.alternative_agency) }}</div>
            <q-icon
              v-if="!userMotorist"
              name="arrow_forward"
              class="q-mx-sm"
              style="color: #37C100; font-size:1.5em"
            />
            <div
              v-if="!userMotorist"
              class="text-subtitle2 text-weight-bold"
              style="color: #172C20"
            >{{ cityToCamelCase(boardingData.destiny) }}</div>
          </div>

          <div class="q-pt-sm" style="border-bottom: 1px solid #ECEDF2"></div>

          <div class="column q-pt-sm">
            <span v-if="boardingData.departure_travel && !userMotorist" class="text-caption" style="color: #014A19">
              Saída dia
              <span
                class="text-weight-bold"
              >{{ boardingData.departure_travel | formatDate }}</span>
            </span>
            <span v-if="boardingData.local_arrival" class="text-caption" style="color: #014A19">
              Chegada
              <span class="text-weight-bold">{{ boardingData.local_arrival | formatDate }}</span>
            </span>
            <span v-if="boardingData.time_pause" class="text-caption" style="color: #014A19">
              Tempo parada:
              <span class="text-weight-bold">{{ boardingData.time_pause }} minutos</span>
            </span>
            <span class="text-caption" style="color: #014A19">
              Saída da agência
              <span
                class="text-weight-bold"
              >{{ boardingData.departure | formatDate }}</span>
            </span>
            <span v-if="boardingData.boarding_amount" class="text-caption" style="color: #014A19">
              Quantidade de embarque:
              <span
                class="text-weight-bold"
              >{{ boardingData.boarding_amount }}</span>
            </span>
            <span v-if="boardingData.landing_amount" class="text-caption" style="color: #014A19">
              Quantidade de desembarque:
              <span
                class="text-weight-bold"
              >{{ boardingData.landing_amount }}</span>
            </span>
          </div>

          <div class="fixed-bottom q-pb-md q-px-lg q-gutter-y-md">
            <q-btn
              @click="boardingData = null, confirmationOpenBoarding = false"
              label="VOLTAR"
              unelevated
              outline
              class="text-weight-bold full-width"
              style="background: white; height: 50px; border-radius: 10px; color: #263A2D"
            />
            <q-btn
              @click="goToPassengersInit(boardingData)"
              label="INICIAR EMBARQUE"
              unelevated
              text-color="white"
              class="text-weight-bold full-width"
              style="background: #016D65; height: 50px; border-radius: 10px"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="validOriginAgency"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-white" style="width: 300px; background-color: #152C1E">
        <q-card-section>
          <div class="text-h6">Atenção!</div>
        </q-card-section>

        <q-card-section
          class="text-subtitle2 text-weight-medium"
          style="line-height: 1"
        >Sua agência de trabalho não é a mesma da origen pesquisada.</q-card-section>

        <q-card-actions align="right" class="bg-white" style="color: #152C1E">
          <q-btn flat label="OK" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { vaiParaUrl, getLocalStorage, dateBRtoEUA, getHost } from "../functions";

import { mutations, store } from "../store";
import {
  SCHEDULES,
  USER,
  USER_AGENCY,
  USER_AGENCY_CODE,
  USER_MOTORIST
} from "../variables";
import { cityToCamelCase, formatDate, getSessionStorage } from "../functions";
import SearchBus from "../components/boarding/SearchBus.vue";

export default {
  components: {
    SearchBus
  },

  filters: {
    formatDate
  },

  data() {
    return {
      user: "",
      buttonActive: "naoIniciado",
      confirmationOpenBoarding: false,
      boardingData: null,
      schedulesOpens: [],
      colorMenuCard: "#030003",
      indicatorColor: "black",
      userAgency: "",
      userAgencyCode: "",
      userMotorist: 0,
      validOriginAgency: false,
      intervalSchedulesUpdate: null
    };
  },

  watch: {
    buttonActive: function() {
      if (this.buttonActive === "naoIniciado") {
        this.colorMenuCard = "#030003";
        this.indicatorColor = "black";
      } else if (this.buttonActive === "emAndamento") {
        this.colorMenuCard = "#FFE300";
        this.indicatorColor = "warning";
      } else if (this.buttonActive === "concluido") {
        this.colorMenuCard = "#20C600";
        this.indicatorColor = "positive";
      }
    }
  },

  computed: {
    origin: {
      get() {
        return JSON.parse(JSON.stringify(store.origin));
      },
      set(value) {
        mutations.setOrigin(value);
      }
    },

    destiny: {
      get() {
        return store.destiny;
      },
      set(value) {
        mutations.setDestiny(value);
      }
    },

    date: {
      get() {
        return store.date;
      },
      set(value) {
        mutations.setDate(value);
      }
    },

    schedules: {
      get() {
        if (store.schedules === null) {
          return [];
        }
        return store.schedules.filter(
          s => s.filtered === undefined || s.filtered
        );
      },
      set(value) {
        mutations.setSchedules(value);
      }
    },

    motoristTravel: {
      get() {
        return store.motoristTravel;
      },
      set(value) {
        mutations.setMotoristTravel(value);
      }
    },
  },

  mounted() {
    this.getSchedules();
    this.userAgency = getLocalStorage(USER_AGENCY);
    this.user = getLocalStorage(USER);
    this.userAgencyCode = getLocalStorage(USER_AGENCY_CODE);
    this.userMotorist = getLocalStorage(USER_MOTORIST);
    this.getSchedulesOpens();
    mutations.setHeaderTitle(this.userMotorist ? "Lista de locais de embarque" : "Lista de viagens");
    this.automaticUpdateSchedules(5);
  },

  beforeDestroy() {
    clearInterval(this.intervalSchedulesUpdate);
  },

  methods: {
    cityToCamelCase,

    getSchedules() {
      let s = getSessionStorage(SCHEDULES);
      if (s != null) {
        store.schedules = s;
      } else {
        store.schedules = [];
      }
    },

    goToPassengersInit(travel) {
      let struct = {
        travel_id: travel.travel_id,
        user_agency: this.origin ? this.origin.code : travel.boarding_code,
        alternative_agency: travel.boarding_alternative ? travel.boarding_alternative_code : ''
      };

      window.http
        .post(`${getHost()}/eucaturmobile/boarding/open`, struct)
        .then(r => {
          if (r.data.id === 0) {
            mutations.openAlert({
              open: true,
              message: r.data.message,
              status: 300
            });
            vaiParaUrl("/pesquisar");
            return;
          }
          mutations.openAlert({
            open: true,
            message: "Embarque iniciado.",
            status: 200
          });
          travel.id = r.data.id;
          mutations.setTravel(travel);
          mutations.setSelectedSchedule(travel);
          vaiParaUrl("/embarque");
        })
        .catch(() => {
          mutations.openAlert({
            open: true,
            message: "Erro ao iniciar embarque.",
            status: 500
          });
        });
    },

    validOriginUserToOpenTravel(travel) {
      if ( this.origin && this.userAgencyCode != this.origin.code && this.userMotorist == 0) {
        this.validOriginAgency = true;
        return;
      } else { 
        this.boardingData = travel; 
        this.confirmationOpenBoarding = true;
      }
    },

    goToPassengers(travel) {
      mutations.setTravel(travel);
      mutations.setSelectedSchedule(travel);
      vaiParaUrl("/embarque");
    },

    getSchedulesOpens() {
      window.http.get(`${getHost()}/eucaturmobile/boarding`).then(r => {
        this.schedulesOpens = r.data;
      });
    },

    filterByStatusBoarding() {
      return this.schedules.filter(
        v => v.boarding_status === this.buttonActive
      );
    },

    howManySchedulesTypes(type) {
      return this.schedules.filter(v => v.boarding_status === type).length;
    },

    automaticUpdateSchedules(intervalInMinutes) {
      const intervalInMilliseconds = intervalInMinutes * 60 * 1000;
      this.intervalSchedulesUpdate = setInterval(() => {
        mutations.setSchedules([]);

        if (this.userMotorist) {
          window.http
            .get(`${getHost()}/eucaturmobile/list-motorist-boarding`, this.motoristTravel)
            .then(r => {
              this.schedules = r.data;
            });
        } else {
          const uri = `${getHost()}/schedules?origin=${
            this.origin.code
          }&destiny=${this.destiny.code}&date=${dateBRtoEUA(this.date)}`;
          window.http.get(uri).then(r => {
            this.schedules = r.data;
          });
        }
      }, intervalInMilliseconds);
    }
  }
};
</script>

<style lang="scss">
.material-icons.q-icon.q-tabs__arrow.q-tabs__arrow--right.absolute.q-tab__icon {
  display: none;
}

.material-icons.q-icon.q-tabs__arrow.q-tabs__arrow--left.absolute.q-tab__icon {
  display: none;
}

.schedules {
  background: #eaeaea;
}

.departure-date {
  font-weight: 500;
}

.schedules__title {
  display: flex;
  width: 100%;
  align-items: center;
}

.schedules__title-icon {
  font-size: 18px;
  display: flex;
}

.schedules__title-texte {
  width: 100%;
  display: flex;
  margin-left: 1%;
  text-transform: uppercase;
  justify-content: space-between;
}

.schedules__section {
  padding: 4px 5px 12px 5px;
}

.schedules__travels {
  padding: 10px 0 80px 0;
}

.my-custom-toggle {
  border: 1px solid #027be3;
}
</style>
